import { render } from "./Pallets.vue?vue&type=template&id=373ea02e"
import script from "./Pallets.vue?vue&type=script&lang=ts"
export * from "./Pallets.vue?vue&type=script&lang=ts"
script.render = render

export default script